
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.96 32.06"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.49 32.06A3.54 3.54 0 0113 31L1 19a3.5 3.5 0 015-4.9l9.46 9.46L36.93 1.08A3.5 3.5 0 0142 5.92L18 31a3.5 3.5 0 01-2.49 1.08z"}})])
          )
        }
      }
    